import { Navigate } from "react-router-dom";
import { LOCALSTORAGE_SELECTED_STATE_CODE } from "./constants";

export default function StateGuard({ children }) {
  const stateId = localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_CODE);

  if (!stateId) {
    return <Navigate to="/" replace />;
  }

  return children;
}